import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranslationInvoked.meta';

export type UseTrackTranslationInvokedParams = {
  surface: 'canvas';
};

export const useTrackTranslationInvoked = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranslationInvoked = useCallback(
    (params: UseTrackTranslationInvokedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTranslationInvoked };
};
